import { render, staticRenderFns } from "./ABTestRoute.vue?vue&type=template&id=235db718&"
import script from "./ABTestRoute.vue?vue&type=script&lang=js&"
export * from "./ABTestRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235db718')) {
      api.createRecord('235db718', component.options)
    } else {
      api.reload('235db718', component.options)
    }
    module.hot.accept("./ABTestRoute.vue?vue&type=template&id=235db718&", function () {
      api.rerender('235db718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/ABTest/ABTestRoute.vue"
export default component.exports